import { render, staticRenderFns } from "./PropertiesMapBox.vue?vue&type=template&id=39942493&"
import script from "./PropertiesMapBox.vue?vue&type=script&lang=js&"
export * from "./PropertiesMapBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports